// Central app configuration constants
export const SUPPORT_EMAIL = "securemaintpro@outlook.com";

// Orders & Licensing Service — a SEPARATE Emergent deployment (Option X).
// The private Ed25519 key + all signing/payment logic live in that project, NOT here.
// Base origin is configured via env; the website only calls its public API.
export const ORDERS_API_URL = process.env.REACT_APP_ORDERS_API_URL || "";

// Payments flag — flip to true once the separate Orders & Licensing service (Mollie/iDEAL) is live.
// While false, the checkout composes a pre-filled order email instead of calling the payment API.
export const PAYMENTS_ENABLED = false;

// Portal add-on pricing (excl. BTW) used by the shop checkout calculator
export const PORTAL_ADDON = { monthly: 24.99, annual: 299.88 };

// Customer portal (separate Emergent deployment, reached via subdomain)
export const PORTAL_URL = "https://portaal.securemaintpro.nl";
export const PORTAL_LOGIN_URL = `${PORTAL_URL}/login`;
export const PORTAL_REQUEST_URL = `${PORTAL_URL}/aanvraag`;

// SecureMaintPro Academy — official YouTube channel
export const YOUTUBE_URL = "https://www.youtube.com/@SecureMaintPro";

// Official LinkedIn company page
export const LINKEDIN_URL = "https://www.linkedin.com/company/securemaintpro/";
